import { Box, Theme } from '@mui/material';
import { ProgressBarProps } from './types';

export const ProgressBar: React.FC<ProgressBarProps> = ({
  percent,
  fillBackground,
  height = 10,
  glowColor,
  shimmer = false,
}) => (
  <Box
    sx={(theme: Theme) => ({
      position: 'relative',
      height,
      width: '100%',
      borderRadius: 999,
      backgroundColor: theme.palette.gray[200],
      overflow: 'hidden',
    })}
  >
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        width: `${Math.min(100, Math.max(0, percent))}%`,
        borderRadius: 999,
        background: fillBackground,
        boxShadow: glowColor ? `0 0 12px ${glowColor}80` : 'none',
        transition: 'width 0.6s ease',
        overflow: 'hidden',
        ...(shimmer && {
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.45) 50%, transparent 100%)',
            transform: 'translateX(-100%)',
            animation: 'progressShimmer 1.6s linear infinite',
          },
          '@keyframes progressShimmer': {
            '0%': { transform: 'translateX(-100%)' },
            '100%': { transform: 'translateX(100%)' },
          },
          '@media (prefers-reduced-motion: reduce)': {
            '&::after': { animation: 'none', opacity: 0 },
          },
        }),
      }}
    />
  </Box>
);
